module.exports = __webpack_public_path__ + "img/WOOCOMMERCE_LARGE.5ab87842.svg";